import ModuleWrapper from 'shared-lib/containers/Module';

const Proxies = () => import(/* webpackChunkName: "proxies" */ '@/views/proxies/Proxies');
const ProxyDetails = () => import(/* webpackChunkName: "proxy-details" */ '@/views/proxies/ProxyDetails');

const meta = (data = {}) => ({
    title: 'Proxies',
    auth: true,
    isSupport: true,
    ignorePrivilege: true,
    ...data,
});

export default [{
    path: 'proxies',
    component: ModuleWrapper,
    meta: meta(),
    children: [
        {
            path: '',
            name: 'Proxies',
            component: Proxies,
            meta: meta(),
        },
        {
            path: ':id(\\d+)',
            name: 'Proxy Details',
            props: true,
            component: ProxyDetails,
            meta: meta(),
        },
    ],
}];
